import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrl = "dossier/check/template/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'templateCode',
            label: '模板编号',
            width: 100
        },
        {
            key:'templateTitle', 
            label: '模板标题',
            width: 100
        },
        {
            key: 'folderName',
            label: '所属目录',
            width: 100
        },
        {
            key: 'realName',
            label: '操作人',
            width: 100
        },
        {
            key: 'createTime', 
            label: '创建时间',
            width: 100
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        if (response.code === 200) {
            return {
                data: response.payload.data,
            }
        }
    })
    .then(res => (
        Object.assign({
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const save = (data) => {
    return fetch.post(`${prefixUrl}save`, data)
}

const update = (id, data) => {
    return fetch.post(`${prefixUrl}update/` + id, data);
}

const querySearchById  = (id) => {
    return fetch.get(`${prefixUrl}get/`+id).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const getForInput  = (id) => {
    return fetch.get(`${prefixUrl}getForInput/`+id).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    columns,
    removeByIds,
    save,
    update,
    querySearchById,
    getForInput
}